/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from '@bottlebooks/gatsby-design-system/src/components/icons/sizes';

/**
 * A star icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {'filled' | 'hollow'} [props.variant]
 * @param {import('@bottlebooks/gatsby-design-system/src/components/icons/sizes').IconSize} [props.size] The icon size.
 */
export default function UnserWeinHeartIcon({
  size = 'small',
  variant = 'filled',
  ...rest
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'sub',
      }}
      // viewBox="0 0 113.4 113.4"
      viewBox="7 7 100 100"
      fill="none"
      {...rest}
    >
      {variant === 'filled' && (
        <path
          fill="#fff"
          d="M77.4 23c-8.4 0-15.9 4.3-20.3 10.7C52.8 27.3 45.3 23 36.9 23c-13.5 0-24.5 11-24.5 24.5 0 4.2 1 8.1 2.9 11.5 9.1 18.3 37.9 32.2 41.9 34 4-1.9 32.7-15.7 41.9-34 1.8-3.4 2.9-7.3 2.9-11.5C101.9 34 90.9 23 77.4 23z"
        />
      )}
      <path
        fill="currentColor"
        d={
          variant === 'filled'
            ? 'M77.4 23c-8.4 0-15.9 4.3-20.3 10.7C52.8 27.3 45.3 23 36.9 23c-13.5 0-24.5 11-24.5 24.5 0 4.2 1 8.1 2.9 11.5 9.1 18.3 37.9 32.2 41.9 34 4-1.9 32.7-15.7 41.9-34 1.8-3.4 2.9-7.3 2.9-11.5C101.9 34 90.9 23 77.4 23z'
            : 'M77.4 30c9.6 0 17.5 7.8 17.5 17.5 0 2.9-.7 5.7-2.1 8.2v.2c-6.1 12.1-24 23.5-35.6 29.4-3.4-1.7-9.1-4.8-15.1-8.9-10.2-6.9-17.3-14-20.5-20.5v-.2c-1.4-2.6-2.1-5.3-2.1-8.2C19.5 37.9 27.3 30 37 30c5.8 0 11.2 2.9 14.5 7.7l5.8 8.5 5.8-8.5c3.1-4.8 8.5-7.7 14.3-7.7m0-7c-8.4 0-15.9 4.3-20.3 10.7C52.8 27.3 45.3 23 36.9 23c-13.5 0-24.5 11-24.5 24.5 0 4.2 1 8.1 2.9 11.5 9.1 18.3 37.9 32.2 41.9 34 4-1.9 32.7-15.7 41.9-34 1.8-3.4 2.9-7.3 2.9-11.5C101.9 34 90.9 23 77.4 23z'
        }
      />
    </svg>
  );
}
